export default {
  "content": "<defs><clipPath id=\"icon_pin_rounded_filled_svg__a\"><path d=\"M0 0h32v32H0z\"/></clipPath></defs><g clip-path=\"url(#icon_pin_rounded_filled_svg__a)\"><path d=\"M16 10.932a2.396 2.396 0 00-2.401 2.39A2.396 2.396 0 0016 15.714a2.397 2.397 0 002.401-2.39A2.397 2.397 0 0016 10.932z\"/><path fill-rule=\"evenodd\" d=\"M16 0C7.16 0 0 7.16 0 16s7.16 16 16 16 16-7.16 16-16S24.84 0 16 0zm-.659 7.532a6.671 6.671 0 011.318 0c4.218.425 6.46 5.227 4.42 8.914l-4.144 7.501c-.202.372-.563.553-.935.553s-.733-.191-.935-.552l-4.144-7.502c-2.04-3.687.202-8.49 4.42-8.914z\" clip-rule=\"evenodd\"/></g>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "32",
    "height": "32",
    "fill": "currentColor",
    "viewBox": "0 0 32 32"
  }
};